<template>
  <div class="animated fadeIn">
    <b-row > 
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <i class="icon-note"></i> Comparativo Cartera Vs Contabilidad PaCo
          </div>
          <b-row>
            <b-col cols="12" col md="2">
            <date-picker
              v-model="fechaSelect"
              type="month"
              :editable="false"
              style="width:90%"
            >
            </date-picker>
          </b-col>
          <b-col cols="12" col md="6">
            <b-button
              pill
              size="sm"
              variant="success"
              :disabled="!fechaSelect"
              @click="getRegistros"
            >
              Ver Registros <i class="fa fa-eye"></i>
            </b-button>
          </b-col>
          </b-row>
        </b-card>
        </b-col>
        
     </b-row>
     <section v-show="cargando">
          <loader-ag />
          <b-row>
            <p class="text-primary mx-auto">Por favor espere...</p>
          </b-row>
        </section>
        <b-row v-show="!cargando">
          <b-col cols="12">
            <b-card>
            <table class="table table-condenced">
              <tr>
                <td class="text-info"><strong>Cuenta</strong></td>
                <td class="text-info"><strong>Nombre</strong></td>
                <td class="text-center text-info"><strong>Saldo Cartera</strong></td>
                <td class="text-center text-info"><strong>Saldo Contabilidad</strong></td>
                <td class="text-center text-info"><strong>Diferencia</strong></td>
                <td></td>
              </tr>
              <tr v-for="(d, index) in items" :key="index">
                <td v-text="d.cuenta"></td>
                <td v-text="d.nombre"></td>
                <td class="text-right">{{d.saldo_prim | currency("", 2, {thousandsSeparator: ","}) }}</td>
                <td class="text-right">{{d.saldo_contabilidad | currency("", 2, {thousandsSeparator: ","}) }}</td>
                <td class="text-right">{{d.diferencia | currency("", 2, {thousandsSeparator: ","}) }}</td>
                
                
              </tr>
            </table>
          </b-card>
          </b-col>
        </b-row>
    </div>
</template>

<script>
import LoaderAg from "../../components/LoaderAg";
import toastr from "toastr";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
import Vue2Filters from "vue2-filters";
import _ from "lodash";
export default {

  name: "comparativa",
  mixins: [Vue2Filters.mixin],
  components: { DatePicker, LoaderAg },
  data: () => {
    return {
      cargando: false,
      fechaSelect: undefined,
      aniomes: undefined,
      items: [],
    };
  },

  methods: {

    async getRegistros() {
      this.items = [];
      this.cargando = true;
      let datos = [];
      try {
        const fecha = this.aniomes.split("-");
        // eslint-disable-next-line no-undef
        let { data } = await axios.post("/api/reportes/comparativo", {
          anio: fecha[0],
          mes : fecha[1]
        });
        
        this.items = data.datos ? data.datos : [];
      } catch (error) {
        this.cargando = false;
        console.log(error);
      }
      this.cargando = false;
    },



    cambiarFormatoFecha(date) {
      // eslint-disable-next-line no-undef
      this.aniomes = moment(date).format("YYYY-MM");
    }
  },
  watch: {
    fechaSelect: _.debounce(function(date) {
      this.cambiarFormatoFecha(date);
    }, 30)
  }

};
</script>
